import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { deleteStage } from '../index';
export const useDeleteStage = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(deleteStage, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetStagesDescription');
            setAction({
                type: 'success',
                message: 'Removing the stage was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
